
export const contentData = [
  //!Scrape-Garden
  {
    category: ["mobile_games"],
    title: "Scrape Garden",
    date: "2025",
    location: null,
    description: "Double Sided puzzle with Gardening theme inspired stack puzzle game",
    detailed_description:
        "Scrape Garden is a puzzle game developed at Teek Games, combining dual-layered matching mechanics with a farmer’s market theme. Players cut crops on stacked grids to create satisfying combos and clear boards with strategic planning. \n I contributed as both the level designer and product manager, working closely with the team to shape the game’s difficulty curve, user flow, and overall pacing. I particularly enjoyed how we aligned the core mechanic with the game’s aesthetic, making every action feel both tactile and thematic. \n This project stands out to me for its playful tone and well-executed mechanic fusion — a great example of cross-functional collaboration within a small team.",
    skills: "Design, Team Management, Game Publishing, Unity",
    genre: " Dock Sort Puzzle",
    role: " Ideation, Level Design, Creative Direction and project management",
    job_type:
        "Game Design and Product Management",
    image:
      "https://i.imgur.com/Y5ryYYf.jpeg",
    images: [
      "https://play-lh.googleusercontent.com/N1_XZAF35oPH1bqv_kguczqpd0WBIUDiz-sd4iHQG_cxsl80UBzcA40-yAT2wP0oJQ=w5120-h2880",
      "https://play-lh.googleusercontent.com/hjM9sSgTkl4gGFJaYeQL3aYnkvmuvXCOSd2E2IUlG2Au7GSB3OO5LnU4R2bidRvZpA=w5120-h2880",
      "https://play-lh.googleusercontent.com/LCHfn2OMgwzGIAZMynNDIPhIYeNv8p4y5PRpiz0Cx3wDSd4CB20JN8W8nJV-V7faOA=w5120-h2880",
    ],
    google_play_link: 
    "https://play.google.com/store/apps/details?id=com.TeekGames.ScrapeGarden",
    behance_link: null,
    horizontalImages: true,
    
  },
  //!Hexa Dial
  {
    category: ["mobile_games"],
    title: "HEXADIAL",
    date: "2025",
    location: null,
    description: "Stack hexagon game with a twist, moving platforms",
    detailed_description:
        "Hexa-Dial is a fast-paced puzzle game built around a unique mechanic: moving platforms that dynamically shift hexagonal tiles for sorting. I ideated and implemented the core mechanic, designed the levels, and managed the project from concept to release. \n What I enjoyed most about this project was introducing motion into a typically static genre. The added challenge of anticipation gave the game a fresh twist.",
    skills: "Design, Team Management, Game Publishing, Unity",
    genre: "Puzzle",
    role: " Ideation, Level Design, Creative Direction and project management",
    job_type:
        "Game Design and Product Management",
    image:
    "https://i.imgur.com/mKueI4F.png",
    images: [
      "https://is2-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/70/eb/27/70eb27e7-0509-3567-92d6-27c6e6c5dfa8/Level_14_1080p_02.01.2025_14-30-22.png/0x0ss.png",
      "https://is2-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/c1/0a/c5/c10ac596-8ac5-b52d-1867-8dc54a51790a/Level_10_1080p_02.01.2025_14-32-45.png/0x0ss.png",
      "https://is2-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/fa/23/af/fa23af29-b81d-9d45-f2e1-5d9dded0ca03/Level_11_1080p_02.01.2025_14-33-24.png/0x0ss.png"
    ],
    app_store_link:
    "https://apps.apple.com/us/app/hexa-dial/id6739133538",
    behance_link: null,
    horizontalImages: true,
  },
  //!Mega-Harvester
  {
    category: ["mobile_games"],
    title: "Mega Harvester",
    date: "2023",
    location: null,
    description: "Harvesting themed Simulation Game with more than 5M+ downloads on Google Play",
    detailed_description:
        "Mega Harvester is one of the largest projects I’ve worked on, developed in collaboration with HOMA. The idea began with exploring the first-person perspective of heavy-duty machinery in a more grounded and realistic way. We focused on log cutting as the core mechanic, then built on it with progression systems, upgrades, and city-building elements. \n The game’s core loop was inspired by Build Brigade (also published by HOMA), featuring a satisfying cycle of resource gathering, machine upgrading, order delivery, and city development. We introduced a seasonal structure, where each season brought new tree types, distinct city layouts, and a clear completion goal: finishing all buildings within that season’s map. \n The game was well received, reaching over 5 million installs on Google Play alone, and praised for its immersive perspective and satisfying progression. \n I contributed across many areas of development, primarily leading the production cycle, owning the level design, and collaborating on core gameplay systems.",
    skills: "Design, Team Management, Game Publishing, Unity",
    genre: "Simulation",
    role: "Level Design and Product Management",
    job_type:
        "Game Design and Product Management",
    image:
      "https://i.imgur.com/IaTVD5H.jpeg",
    images: [
      "https://i.imgur.com/PMhkgHd.png",
      "https://i.imgur.com/wb1lPQf.png",
      "https://i.imgur.com/Hvtp3rV.png",
    ],
    app_store_link:
    "https://apps.apple.com/tr/app/mega-harvester-lumber-factory/id6458691785",
    google_play_link: 
    "https://play.google.com/store/apps/details?id=com.makemake.megaharvester",
    behance_link: null,
    horizontalImages: true,
    videoUrl: "https://www.youtube.com/embed/GL7e0V1g6TA?si=3Fq1A289WlXVfEXw",
  },
  //!Carpet-Cleaning
  {
    category: ["mobile_games"],
    title: "Carpet Cleaning",
    date: "2023",
    location: null,
    description: "Cleaning themed Simulation game with more than 500K+ downloads on Google Play",
    detailed_description:
        "Inspired by the popularity of ASMR content and the success of My Perfect Hotel, Carpet Cleaning blends satisfying texture-cleaning mechanics with simulation gameplay. We designed a two-step system where players first foam and then squeegee carpets clean, using intuitive touch gestures to erase layers of dirt and reveal vibrant patterns. <br/> After the initial prototype, we gradually expanded the game loop by introducing larger carpets, VIP customers, carpet disinfecting, and furniture cleaning. These additions added variety and depth to the experience, making the overall gameplay more immersive and engaging. \n I was responsible for level design and product management, focusing on progression pacing, content variety, and player satisfaction. This project was a fun challenge in crafting mechanics that delivered both visual payoff and tactile pleasure, resonating with the core ASMR audience.",
    skills: "Design, Team Management, Game Publishing, Unity",
    genre: "Simulation",
    role: "Level Design and Product Management",
    job_type:
        "Game Design and Product Management",
    image:
    "https://i.imgur.com/mRExpu2.jpeg",
      //"https://play-lh.googleusercontent.com/YikvONXBb_TpXJ2JwwrXWs1wV4QkvB73_wFu4-cXOz-0As3ECgFvYl0PgjkT-jrLaQ=w5120-h2880",
    images: [
      "https://play-lh.googleusercontent.com/urgephB5E86LpfDan1tV8jdIxcIOyt3k90ldBZ37nXBOpGzOrbZhsufMPinlS_nhjw=w5120-h2880",
      "https://play-lh.googleusercontent.com/jL23m9KEsHATwQr2SulTuAdu2hmOmyHGmOyCe01l-TxY7CJ7PwvddHkH7vLPnDvZSY8=w5120-h2880-rw",
      "https://play-lh.googleusercontent.com/mfc8FfgFkJj0FyqUuF-wmnwAGf3uuNAwelH3q3w4fRVhfw7GJfXQZuJTaDwtlnske9to=w5120-h2880-rw",
    ],
    app_store_link:
    "https://apps.apple.com/tr/app/carpet-cleaning-asmr/id6501984874",
    google_play_link: 
    "https://play.google.com/store/apps/details?id=com.makemake.carpetcleaning",
    behance_link: null,
    horizontalImages: true,
    videoUrl: "https://www.youtube.com/embed/Vcq6cl-B674",
  },
//!Delicious-Eating-Simulator
  {
    category: ["mobile_games"],
    title: "Delicious Eating Simulator",
    date: "2022",
    location: null,
    description: "Mukbang Simulator with a live stream theme",
    detailed_description:
        "In this game, players prepare meals for a streamer character, whose audience reacts in real-time once the stream begins. After each dish is served, viewers comment on which food they want next — and choosing the right one boosts your viewer count. The goal is to hit a target number of viewers by the end of each plate. I was responsible for level design in Unity, and I also oversaw the production pipeline, coordinating both asset creation and programming throughout development. This project was especially fun to work on due to its playful theme and reactive gameplay loop. It also tested well during its CPI phase in 2022, showing promising results for marketability.",
    skills: "Design, Team Management, Game Publishing, Unity",
    genre: "Simulation",
    role: "Level Design and Product Management",
    job_type:
        "Game Design and Product Management",
    image:
    "https://i.imgur.com/OqcV2sI.png",
    images: [
      "https://play-lh.googleusercontent.com/_L7xoXovgtQBKbXOE1i65GEE9H2m1W4J6zucd8wSyhATDV9K9K5uhVncI2mhi0IZtO0=w5120-h2880",
      "https://play-lh.googleusercontent.com/boDy-W3ijqbMQVPD4uqJprpF7Zwt1YDZ8rQr273tHZI5LIJpnWu-UcXQkyfOhVvW1K30=w5120-h2880",
      "https://play-lh.googleusercontent.com/UOTxFglMG39ViYmsdMISoZvI4JIdvcYh-uZ7AM-uxpNKgvIyKxKwe2dWrrCYvmO2OhY=w5120-h2880",

    ],
    google_play_link: 
    "https://play.google.com/store/apps/details?id=com.makemake.deliciouseatingsimulator",
    behance_link: null,
    horizontalImages: true,
    videoUrl: "https://www.youtube.com/embed/k1_qqGzOt9Q",
  },
//!Plantoid
{
  category: ["mobile_games"],
  title: "Plantoid",
  date: "2022",
  location: null,
  description: "Space Farming Simulator with cute Beasts",
  detailed_description:
      "Plantoid is one of the most ambitious projects I’ve worked on — a casual farming and creature-breeding game originally designed with the potential to evolve into a blockchain-integrated experience as part of a collaboration between Voodoo and Tencent. In the initial phases, the game was developed and released as a mobile farming simulator, where players cultivated crops and bred alien-like creatures within a dynamic resource system. The long-term vision included turning these creatures into NFT collectibles within a player-owned ecosystem. I was responsible for in-game economy design and project planning, particularly during a two-month design phase where we explored mechanics, progression, and monetization strategies. I used Machinations to map and document the game’s currency flow, helping ensure a balanced and engaging economic loop which was a great learning experience!",
  skills: "Design, Team Management, Game Publishing, Unity",
  genre: "Simulation",
  role: "Ideation, Documentation, Economy Design, Product Management",
  job_type:
      "Game Design and Product Management",
  image:
  "https://i.imgur.com/hoxY7T9.jpeg",
  images: [
    "https://play-lh.googleusercontent.com/W4adb0C14ZhcjnBIlhCGA1qEz4oj0kGHs4Gr2VP_x-9CYjHpKoqNg8o0Zb11CsOxtrCA=w5120-h2880",
    "https://play-lh.googleusercontent.com/7NtgLjTrY6mksIxTsD5h2a89pZgBvPBsJUYSjh6MCVrz1C2R_2QE82yZOy151N9ApjvI=w5120-h2880",
    "https://play-lh.googleusercontent.com/CVVzfxzENI79NA9tosVWNpyQmDlux2y6QzzIDdQeks7IyBEuRIBDx1qAvc6fSP16-kM=w5120-h2880",
  ],
  google_play_link: 
  "https://play.google.com/store/apps/details?id=com.makemake.plantoid",
  app_store_link:
  "https://apps.apple.com/tr/app/plantoid/id1620214221",
  behance_link: null,
  horizontalImages: false,
  Machinations_Link: "https://my.machinations.io/d/publicver-plantoid---mvp/49c83b8225fe11f0abac028ecffc1261",
  videoUrl: "https://www.youtube.com/embed/f1OffPkhnyA?si=yxLQQx9wpOGygOHS",
},
//!NKIMMM
{
  category: ["pc_games"],
  title: "NKIMMM",
  date: "2020",
  location: null,
  description: "Interactive Personal Story about Loss and Grief // Bilgi Digital Game Design 2020 Graduation Project",
  detailed_description:
      "NKIMMM is an interactive narrative experience developed as part of my 2020 Graduation Project at Bilgi University’s Digital Game Design program. Told through a written letter from the protagonist to their late mother, the game explores the complex emotions surrounding loss, grief, and remembrance. The player is invited into this intimate journey, experiencing the protagonist’s thoughts and memories through their own words. This was a deeply personal project. I created NKIMMM as a way to process my own experience with loss — not just to understand it better, but to give myself time and space with the subject. The graduation project offered the perfect opportunity to approach something so personal through the medium of games. And it truly was.",
  skills: "Design, C#, Unity, Art, Sound",
  genre: "Interactive Story",
  role: "Ideation, Documentation, 3D and 2D Art, Sound Design, Interactive Programming in Unity with Kinect Sensor, Project Owner",
  job_type:
      "Project Owner",
  image:
  "https://i.imgur.com/9d8RC7s.png",
  images: [
    "https://img.itch.zone/aW1hZ2UvNjc0OTc5LzM3MTAxOTQucG5n/original/dTL3ok.png",
    "https://img.itch.zone/aW1hZ2UvNjc0OTc5LzM3MTAxOTMucG5n/original/MGFw93.png",
    "https://img.itch.zone/aW1hZ2UvNjc0OTc5LzM3MTAxOTUucG5n/original/CXECqA.png",
  ],
  web_link: "https://yegenaga.itch.io/nkimmm",
  behance_link: null,
  horizontalImages: false,
  videoUrl: "https://www.youtube.com/embed/5q60fkn8BqI?si=6eTfse9hUT2v7KA0",
},
//!Will
{
  category: ["pc_games"],
  title: "Will",
  date: "2018",
  location: null,
  description: "An existential short story // GameJam.03 'Borders' themed game jam Entree ",
  detailed_description:
      "Will is a first-person role-playing game created for GameJam.03, developed under the theme of “Borders.” The game explores the invisible limitations we place on ourselves — shaped by desire, culture, society, and norms — and how willpower plays a role in challenging or submitting to those boundaries. The player joins the protagonist, Will, on a reflective journey through memory and constraint, questioning the borders of choice, identity, and self-perception. The gameplay was inspired by Walter Benjamin’s Angel of History — portraying time not as progress, but as an accumulation of recurring moments. Players repeat the same sequence of choices in a loop, gradually testing their own will and agency within a world that resists change. I contributed to the game’s narrative and conceptual design, shaping its philosophical foundation and emotional progression. The game was well received at the game jam, praised for its thematic depth and experimental approach to narrative design.",
  skills: "Design, C#, Unreal Engine,, Art, Sound",
  genre: "Adventure",
  role: "Ideation, Documentation, Sound Design",
  job_type:
      "Project Owner",
  image:
  "https://i.imgur.com/9esdQSx.jpeg",
  images: [
    "https://img.itch.zone/aW1hZ2UvMjM4Mzc5LzExMzUxODYucG5n/original/xlfRHd.png",
    "https://img.itch.zone/aW1hZ2UvMjM4Mzc5LzExMzUxODgucG5n/original/ujsWKw.png",
    "https://img.itch.zone/aW1hZ2UvMjM4Mzc5LzExMzUxODcucG5n/original/Ekkoka.png",
  ],
  web_link: "https://yegenaga.itch.io/will",
  horizontalImages: false,
},

//!Whack-a-Mole
{
  category: ["physical_games"],
  title: "Whack-a-Mole",
  date: "2018",
  location: null,
  description: "An arcade machine programmed with Arduino.",
  detailed_description:
      "As part of the VCD 491 Physical Interaction Design II course in Spring ’18, my classmate and I developed a physically interactive toy using C++ and Arduino. We chose to recreate a Whack-a-Mole game, where I handled the programming, and my classmate was responsible for the electronics. The game featured a two-player system where each player sat across from each other on a board, aiming to press the lighted button as quickly as possible. The player who presses more buttons wins, and the game restarts after each round. It was a fun and rewarding project, combining coding with hands-on physical design.",
  skills: "C++, Arduino",
  genre: "Physical Game / Arcade",
  role: "Programming, Building",
  job_type:
      "Project Owner",
  image:
  "https://i.imgur.com/wY4npQk.jpeg",
  videoUrl: "https://www.youtube.com/embed/lufwSotspUE?si=Ln2F2ca-cPd1-2G0",
  horizontalImages: false,
},
];
